import OwTitle from "../OwTitle/OwTitle";

export const LoadingResults = () => {
    return <OwTitle title={"loading"} tag={"h5"} rightIconName={"fas fa-sync fa-spin"} />;
}
